<template>
  <div class="main-by">
    <TopNavbar title="基友秀"></TopNavbar>
    <div class="moment-create-box">
      <MomentCreateComponent :refItemId="refItemId" :config="config" @postStatus="onPost"></MomentCreateComponent>
    </div>
  </div>
</template>

<script>
  import MomentCreateComponent from "./MomentCreateComponent";
  import TopNavbar from "../../common/TopNavbar";

  export default {
    name: "MomentCreateGoodsRemarkPage",
    components: {
      TopNavbar,MomentCreateComponent,
    },
    data() {
      return {
        config: {
          scene: "goods_remark"
        },
        refItemId: 0,
      }
    },
    async mounted() {
      let refId = this.$route.params.id
      if (refId) {
        try {
          this.refItemId = parseInt(refId)
        } catch (e) {
        }
      }
    },
    methods: {
      onPost(status) {
        if (status === 0 ) {
          this.$router.go(-1)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main-by {
    min-height: 100vh;
  }
  .moment-create-box {
    padding: 55px 2px 0;
  }

</style>
